import { Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
function BeaconForm(props) {
  const [FID, setFID] = useState("");
  const [Shape, setShape] = useState("");
  const [BAND, setBAND] = useState("");
  const [RANG_MAX, setRANG_MAX] = useState("");
  const [RANG_MIN, setRANG_MIN] = useState("");
  const [CODE, setCODE] = useState("");
  const [MAPTEXT, setMAPTEXT] = useState("");

  useEffect(() => {
    let data = {
      FID: FID,
      Shape: Shape,
      BAND: BAND,
      RANG_MAX: RANG_MAX,
      RANG_MIN: RANG_MIN,
      CODE: CODE,
      MAPTEXT: MAPTEXT,
    };
    props.setData(data);
  }, [FID, Shape, BAND, RANG_MAX, RANG_MIN, CODE, MAPTEXT]);
  return (
    <>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={FID}
            onChange={(e) => setFID(e.target.value)}
            variant="outlined"
            label="FID"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={Shape}
            onChange={(e) => setShape(e.target.value)}
            variant="outlined"
            label="Shape"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={BAND}
            onChange={(e) => setBAND(e.target.value)}
            variant="outlined"
            label="BAND"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={RANG_MAX}
            onChange={(e) => setRANG_MAX(e.target.value)}
            variant="outlined"
            label="RANG_MAX"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={RANG_MIN}
            onChange={(e) => setRANG_MIN(e.target.value)}
            variant="outlined"
            label="RANG_MIN"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={CODE}
            onChange={(e) => setCODE(e.target.value)}
            variant="outlined"
            label="CODE"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={MAPTEXT}
            onChange={(e) => setMAPTEXT(e.target.value)}
            variant="outlined"
            label="MAPTEXT"
            size="small"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default BeaconForm;
